module.exports = __webpack_public_path__ + "fonts/8ce6a630-11cb-4fba-be7f-e9f01c898ea2.310be9e8.eot";